import { Action } from '@ngrx/store';
import { datosModelo } from 'src/app/models/SicarMap/datosModelo.model';


export const SET_MODELO = '[MODELOS] Set MODELO';
export const UPDATE_MODELO = '[MODELOS] Update MODELO';
export const UNSET_MODELO = '[MODELOS] Unset MODELOS';

export class SetModeloAction implements Action {
  readonly type = SET_MODELO;
  constructor(public modeloEjecutado: datosModelo) {}
}

export class UpdateModeloAction implements Action {
  readonly type = UPDATE_MODELO;
  constructor(public modeloEjecutado: datosModelo) {}
}

export class UnsetModeloAction implements Action {
  readonly type = UNSET_MODELO;
  constructor(public IdModelo: string) {}
}

export type ModelosEjecutadosActions =
  | SetModeloAction
  | UpdateModeloAction
  | UnsetModeloAction;

